import { AddIcon } from "@chakra-ui/icons";
import { Box, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import AdsetImage from "./AdsetImage";
import { StepProps } from "./CreateCampaignWizard";
import { Navigation } from "./Navigation";

const AdList = ({
  adset,
  navigateTo,
  setDefaultEditingAd,
  next,
  back,
  steps,
}: StepProps) => {
  const isCreateCampaign = steps.at(0).includes("create_campaign");

  const { ads } = adset || { ads: [] };
  return (
    <VStack w="full" alignItems={"flex-start"} gap={4}>
      <HStack w="full" justifyContent={"flex-start"} alignItems={"flex-start"}>
        <Text
          fontSize={"lg"}
          textTransform={"uppercase"}
          fontWeight={"bold"}
          color={"gray.400"}
        >
          Adset
        </Text>
        <Text fontWeight={"bold"} fontSize={"lg"}>
          {adset?.name}
        </Text>
      </HStack>
      <HStack w="full" justifyContent={"flex-start"} alignItems={"flex-start"}>
        <Text
          fontSize={"lg"}
          textTransform={"uppercase"}
          fontWeight={"bold"}
          color={"gray.400"}
        >
          Ads
        </Text>
      </HStack>
      <HStack w="full" gap={4}>
        {ads.map((ad) => (
          <Box
            key={ad.id}
            position={"relative"}
            aspectRatio={1}
            backgroundColor={"gray.100"}
            rounded="xl"
            width={60}
            height={60}
            overflow={"hidden"}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setDefaultEditingAd(ad);
              navigateTo("edit_creative");
            }}
          >
            <AdsetImage
              adset={{ ads: [ad] }}
              containerProps={{
                height: "100%",
                width: "100%",
              }}
              imageProps={{
                outline: "none",
                height: "100%",
                width: "100%",
                border: "none",
                backgroundColor: "gray.100",
                objectFit: "cover",
                objectPosition: "center",
              }}
            />
            <Box
              alignItems={"center"}
              justifyContent={"center"}
              pos={"absolute"}
              bottom={0}
              py={1}
              w="full"
              display={"flex"}
              backgroundColor={"rgba(255,255,255,0.5)"}
              zIndex={10}
            >
              <Text w="full" fontWeight={"bold"}>
                {ad.name}
              </Text>
            </Box>
          </Box>
        ))}
        <Button
          height={60}
          flexDirection={"column"}
          gap={4}
          rounded="xl"
          onClick={() => {
            navigateTo("create_creative");
          }}
          width={60}
        >
          <AddIcon fontSize={"2xl"} />
          New ad
        </Button>
      </HStack>
      <Navigation
        back={back}
        next={isCreateCampaign ? next : null}
        canNext={isCreateCampaign}
        // canNext
        backLabel="Back"
        nextLabel={isCreateCampaign ? "Next" : "Review"}
      />
    </VStack>
  );
};

export default AdList;
